import {
  GenericVehicleDetails,
  triggerEcommerceOrderingTrackingEvent,
} from '@finn/ua-vehicle';
import { TrackingEventName } from '@finn/ui-modules';
import { useEffect } from 'react';

export const useTracking = (
  vehicle: GenericVehicleDetails,
  isLoading: boolean,
  preDiscountPrice: string
) => {
  useEffect(() => {
    if (isLoading) {
      return;
    }

    triggerEcommerceOrderingTrackingEvent({
      vehicle,
      productInfo: { preDiscountPrice },
      available: Boolean(vehicle?.availability),
      eventName: TrackingEventName.PRODUCT_VIEWED,
    });
  }, [isLoading]);
};
